import {html, LitElement, type TemplateResult} from "lit";
import {customElement, property} from "lit/decorators.js";
import Styles from "../common/tabOutListener.lit.scss";

@customElement("eop-tab-out-listener")
export class EopTabOutListener extends LitElement {

    public static readonly styles = Styles;

    @property()
    public callback: () => void;

    public render(): TemplateResult {
        return html`
            <button @focusin=${this.onTabOut} class="tab-out-button" aria-label="Tab-Out-Element"></button>
        `;
    }

    private onTabOut(e: Event): void {
        e.preventDefault();
        e.stopPropagation();
        this.callback();
    }
}